'use strict';

var _extends = require('../../node_modules/@babel/runtime/helpers/extends.js');
var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
require('prop-types');
var classNames = require('classnames');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');
var grey = require('../../node_modules/@material-ui/core/esm/colors/grey.js');
var TextField = require('../../node_modules/@material-ui/core/esm/TextField/TextField.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var styles = function styles() {
  return {
    inputMarginDense: {
      paddingTop: '7px'
    },
    inputMultiline: {
      padding: '6px 12px 6px 12px'
    },
    underline: {
      "&:before": {
        borderBottomColor: "transparent",
        borderWidth: "1px"
      }
    },
    input: {
      borderRadius: 4,
      backgroundColor: grey[100]
    }
  };
};

var EditableInput = function EditableInput(_ref) {
  var placeholder = _ref.placeholder,
      InputProps = _ref.InputProps,
      multiline = _ref.multiline,
      variant = _ref.variant,
      startAdornment = _ref.startAdornment,
      endAdornment = _ref.endAdornment,
      _ref$classes = _ref.classes,
      input = _ref$classes.input,
      inputMarginDense = _ref$classes.inputMarginDense,
      inputMultiline = _ref$classes.inputMultiline,
      underline = _ref$classes.underline,
      restClasses = objectWithoutProperties(_ref$classes, ["input", "inputMarginDense", "inputMultiline", "underline"]),
      rest = objectWithoutProperties(_ref, ["placeholder", "InputProps", "multiline", "variant", "startAdornment", "endAdornment", "classes"]);

  var inputProps = {
    classes: {
      inputMarginDense: inputMarginDense,
      underline: underline
    },
    startAdornment: startAdornment,
    endAdornment: endAdornment
  };

  if (multiline) {
    inputProps = {
      classes: {
        multiline: inputMultiline
      }
    };
  }

  return React__default["default"].createElement(TextField["default"], _extends["default"]({
    InputLabelProps: {
      shrink: true
    },
    InputProps: _objectSpread({}, inputProps, {}, InputProps, {
      className: classNames__default["default"](input, InputProps.className)
    }),
    variant: variant,
    placeholder: placeholder,
    fullWidth: true,
    multiline: multiline,
    margin: "dense"
  }, restClasses, rest));
};

EditableInput.defaultProps = {
  InputProps: {
    style: {}
  },
  variant: "filled",
  placeholder: ""
};
var EditableInput$1 = withStyles(styles)(EditableInput);

module.exports = EditableInput$1;
